import { render, staticRenderFns } from "./PedigreeOrder.vue?vue&type=template&id=3458bba4"
import script from "./PedigreeOrder.vue?vue&type=script&lang=ts"
export * from "./PedigreeOrder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports